import { dateTimeHelper } from '@tap/utils';
import { ISearchParamsSerializer } from './routing.types';

export type ITypeBasedSearchParamsSerializerProps = {
    keyPrefix: string,
    possibleObjectIds: string[],
}

const defaultProps: ITypeBasedSearchParamsSerializerProps = {
    keyPrefix: '',
    possibleObjectIds: ['key', 'code', 'id'],
};

export class TypeBasedSearchParamsSerializer implements ISearchParamsSerializer {
    props: ITypeBasedSearchParamsSerializerProps;

    constructor(props: Partial<ITypeBasedSearchParamsSerializerProps> = {}) {
        this.props = { ...defaultProps, ...props };
    }

    decodeSearchValue(keyTypeCode: string, val: string | number, objectPropertyName: string = ''): any {
        if (keyTypeCode.length === 0)
            return val;

        if (keyTypeCode.indexOf('n') !== -1) {
            return this.decodeSearchValue(keyTypeCode.replace('n', ''), Number(val), objectPropertyName);
        }

        if (keyTypeCode[0] === 'o') {
            return { [objectPropertyName]: val };
        }

        return val;
    }

    decodeSearchParams(params: URLSearchParams) {
        const result = {} as any;
        for (const key of params.keys()) {
            if (!this.props.keyPrefix || key.startsWith(this.props.keyPrefix)) {
                const cleanKey = key.replace(this.props.keyPrefix, '');
                const keyParts = cleanKey.split('_');
                const keyTypeCode = keyParts[0];

                if (keyParts.length > 1 && keyTypeCode.replace('a', '').replace('o', '').replace('n', '') === '') {
                    let resultKey = cleanKey.replace(`${keyTypeCode}_`, '');


                    let objectPropertyName = this.props.possibleObjectIds[0];
                    if (keyTypeCode.indexOf('o') !== -1) {
                        const keyParts = cleanKey.split('.');
                        const propertyName = keyParts.length > 1 ? keyParts[keyParts.length - 1] : this.props.possibleObjectIds[0];
                        if (this.props.possibleObjectIds.indexOf(propertyName) !== -1) {
                            objectPropertyName = propertyName;
                            resultKey = resultKey.replace(`.${objectPropertyName}`, '');
                        }
                    }

                    if (keyTypeCode[0] === 'a') {
                        const aValues = params.getAll(key);
                        const resultValue = aValues.map(v => this.decodeSearchValue(keyTypeCode.replace('a', ''), v, objectPropertyName));
                        result[resultKey] = resultValue;

                    } else {
                        const pValue = params.get(key);
                        const resultValue = this.decodeSearchValue(keyTypeCode, pValue, objectPropertyName);
                        result[resultKey] = resultValue;
                    }
                } else {
                    result[cleanKey] = params.get(key);
                }
            }
        }
        return result;
    }

    getSearchKey(key: string, value: any, typePrefix: string = ''): string {

        if (value === null || value === undefined) {
            return typePrefix ? `${typePrefix}_${key}` : key;
        } else if (Array.isArray(value)) {
            //return `${key}[]`;
            const notEmptyValues = value.filter(v => v !== undefined && v !== null && v !== '');
            if (!notEmptyValues.length) return key;

            const firstValue = notEmptyValues[0];
            return this.getSearchKey(key, firstValue, 'a');
        } else if (value instanceof Date) {
            return typePrefix ? `${typePrefix}_${key}` : key;
        } else if (typeof value === 'number') {
            return typePrefix ? `${typePrefix}n_${key}` : `n_${key}`;
        } else if (typeof value === 'object') {
            for (const objUKey of this.props.possibleObjectIds) {
                if (value.hasOwnProperty(objUKey)) {
                    return (this.props.possibleObjectIds.length === 1 || objUKey === this.props.possibleObjectIds[0])
                        ? this.getSearchKey(key, value[objUKey], `${typePrefix}o`)
                        : this.getSearchKey(`${key}.${objUKey}`, value[objUKey], `${typePrefix}o`);
                }
            }

            return `${typePrefix}o_${key}`;
        } else {
            return typePrefix ? `${typePrefix}_${key}` : key;
        }
    }


    getSearchValue(value: any): string | null | undefined | any[] {

        if (value === null || value === undefined) {
            return value;
        } else if (Array.isArray(value)) {
            return value.map(v => this.getSearchValue(v));
        } else if (value instanceof Date) {
            return dateTimeHelper.formatDate(value, 'yyyy-MM-dd');
        } else if (typeof value === 'object') {
            for (const objUKey of this.props.possibleObjectIds) {
                if (value.hasOwnProperty(objUKey)) {
                    return value[objUKey];
                }
            }
            return JSON.stringify(value);
        } else {
            return value.toString();
        }
    }

    transformToSearchParams(obj: any) {
        const result = {} as any;
        Object.keys(obj).forEach((k) => {
            const keyPrefix = this.props.keyPrefix || '';
            result[keyPrefix + this.getSearchKey(k, obj[k], '')] = this.getSearchValue(obj[k]);
        });
        return result;
    }
}